export default __webpack_public_path__ + "45c7a577d51ca51c5df354856df602f2.jpg";